import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { DEFAULT_OPEN } from "./meetingDetailsConstants";
import MeetingDetailsAccordionSection from "./MeetingDetailsAccordionSection";

/**
 * Accordion of meeting status sections (grids).
 */
export default function MeetingDetailsAccordion({
  status,
  sectionLoaders,
  meetingDatasources,
  onAccordionSelect,
  gridRef,
  columnDefsMap,
  defaultColDef,
  cellClickedListener,
  onGridReady,
  rowClassRules,
  onSelectionChanged,
  onSortChanged,
  onFilterChanged,
  onRefreshSection,
}) {
  return (
    <Accordion defaultActiveKey={DEFAULT_OPEN} onSelect={onAccordionSelect} alwaysOpen>
      <div className="accrdion-list-grid">
        {status.map((e, i) => (
          <MeetingDetailsAccordionSection
            key={e.type}
            section={e}
            sectionIndex={i}
            isLoading={sectionLoaders[e.type] || false}
            datasource={meetingDatasources[e.type]}
            columnDefs={columnDefsMap[e.type]}
            defaultColDef={defaultColDef}
            cellClickedListener={cellClickedListener}
            onGridReady={onGridReady}
            rowClassRules={rowClassRules}
            onSelectionChanged={onSelectionChanged}
            onSortChanged={onSortChanged}
            onFilterChanged={onFilterChanged}
            gridRef={gridRef}
            onRefreshSection={onRefreshSection}
          />
        ))}
      </div>
    </Accordion>
  );
}
